import { analytics } from './segment-setup'
import { refreshSessionActivityWithTTLCheck, captureSessionStart } from './segment-session'

/**
 * Provides functions to enable segment data collection
 * operations on the segment workspace "Sky-As-An-App".
 */
export const segmentIdentify = (account, currentProfile, checkPrevUserId = false) => {
  const previousIdentifyId = analytics.instance?.user()?.id()
  /* Trigger identify in two scenarios:
  ** checkPrevUserId is false: sign in, sign up, switch profile
  ** checkPrevUserId is true: check if current userId is not equal to previous userId while user nav
  */
  if (!checkPrevUserId || account?.cpCustomerID !== previousIdentifyId) {
    const profile = {
      id: currentProfile?.id,
      name: currentProfile?.name
    }
    // Start session on signin/signup (passing userProfile) or refresh TTL, both return activeSessionId
    const activeSessionId = !previousIdentifyId ? captureSessionStart({ userProfile: profile }) : refreshSessionActivityWithTTLCheck()

    analytics.identify(account?.cpCustomerID, {
      email: account?.email,
      firstName: account?.name,
      lastName: account?.surname,
      profile,
      activeSessionId
    })
  }
}

export const hasSegmentUserID = () => {
  const userId = analytics.instance?.user()?.id()
  return Boolean(userId)
}
